export default __webpack_public_path__ + "static/media/001-drilling rig.981a9059.svg";